(() => {
  if (window.NorkayaHomeHeroSlider) return;

  const instances = new WeakMap();
  const sectionSelector = '[data-home-hero-slider-section]';

  class NorkayaHomeHeroSlider {
    constructor(section) {
      this.section = section;
      this.sliderEl = section.querySelector('[data-home-hero-slider]');
      this.slider = null;
      this.prevButtons = [];
      this.nextButtons = [];

      this.init();
    }

    init() {
      if (!this.section || this.section.dataset.homeHeroSliderInitialized === 'true') return;

      this.section.dataset.homeHeroSliderInitialized = 'true';
      this.initSlider();
    }

    initSlider() {
      if (!this.sliderEl || typeof Splide === 'undefined') return;

      const slideCount = this.sliderEl.querySelectorAll('.splide__slide').length;

      this.slider = new Splide(this.sliderEl, {
        type: 'fade',
        rewind: true,
        speed: 700,
        pagination: false,
        arrows: false,
        drag: slideCount > 1,
        autoplay: this.sliderEl.dataset.autoplay === 'true' && slideCount > 1,
        interval: Number(this.sliderEl.dataset.interval) || 5000,
        pauseOnHover: true,
        pauseOnFocus: true
      });

      this.prevButtons = Array.from(this.section.querySelectorAll('.home-hero-slider-section__arrow--prev'));
      this.nextButtons = Array.from(this.section.querySelectorAll('.home-hero-slider-section__arrow--next'));

      this.prevButtons.forEach((button) => {
        button.addEventListener('click', this.handlePrevClick);
      });

      this.nextButtons.forEach((button) => {
        button.addEventListener('click', this.handleNextClick);
      });

      this.slider.on('move', () => {
        this.pauseAllVideos();
      });

      this.slider.on('mounted moved', () => {
        this.playActiveVideo();
      });

      this.slider.mount();
    }

    handlePrevClick = () => {
      if (!this.slider) return;

      this.slider.go('<');
    };

    handleNextClick = () => {
      if (!this.slider) return;

      this.slider.go('>');
    };

    pauseAllVideos() {
      const videos = this.section.querySelectorAll('.home-hero-slider-section__video video');

      videos.forEach((video) => {
        video.pause();
      });
    }

    playActiveVideo() {
      if (!this.slider) return;

      const activeSlide = this.slider.Components.Slides.getAt(this.slider.index)?.slide;
      const activeVideo = activeSlide?.querySelector('.home-hero-slider-section__video video');

      if (activeVideo) {
        activeVideo.play().catch(() => {});
      }
    }

    goToBlock(blockElement) {
      if (!this.slider || !blockElement) return;

      const slide = blockElement.closest('.home-hero-slider-section__slide');

      if (!slide) return;

      const slides = Array.from(this.section.querySelectorAll('.home-hero-slider-section__slide'));
      const index = slides.indexOf(slide);

      if (index >= 0) {
        this.slider.go(index);
      }
    }

    destroy() {
      this.prevButtons.forEach((button) => {
        button.removeEventListener('click', this.handlePrevClick);
      });

      this.nextButtons.forEach((button) => {
        button.removeEventListener('click', this.handleNextClick);
      });

      this.pauseAllVideos();

      if (this.slider) {
        this.slider.destroy(true);
        this.slider = null;
      }

      this.section.dataset.homeHeroSliderInitialized = 'false';
    }

    static init(section) {
      if (!section || instances.has(section)) return;

      instances.set(section, new NorkayaHomeHeroSlider(section));
    }

    static destroy(section) {
      const instance = instances.get(section);

      if (!instance) return;

      instance.destroy();
      instances.delete(section);
    }

    static get(section) {
      return instances.get(section);
    }
  }

  const initSection = (section) => {
    NorkayaHomeHeroSlider.init(section);
  };

  const initSections = () => {
    if (typeof initSectionOnVisible === 'function') {
      initSectionOnVisible({
        selector: sectionSelector,
        threshold: 0,
        rootMargin: '100px 0px 100px 0px',
        init: (section) => {
          initSection(section);
        }
      });

      return;
    }

    document.querySelectorAll(sectionSelector).forEach((section) => {
      initSection(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initSections();
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(sectionSelector);

    if (section) {
      initSection(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector(sectionSelector);

    if (section) {
      NorkayaHomeHeroSlider.destroy(section);
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest(sectionSelector);

    if (!section) return;

    const instance = NorkayaHomeHeroSlider.get(section);

    if (!instance) return;

    instance.goToBlock(event.target);
  });

  window.NorkayaHomeHeroSlider = NorkayaHomeHeroSlider;
})();